export default __webpack_public_path__ + "static/media/yeuxCoulent.b5c99e43.png";